<template>
  <div class="editor-header-report-button__wrapper">
    <aha-icon-button
      @click="$emit('showExport')"
      :variant="canUseNewCleanUpEditorUI ? 'secondary' : 'tertiary'"
      v-tooltip="$i18nPresenter.t('View presentation report')"
      class="editor-header-report-button"
    >
      <aha-icon
        :name="iconName"
        viewBox="0 0 16 16"
        :width="iconSize"
        :height="iconSize"
      />
    </aha-icon-button>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters('featureToggles', ['canUseNewCleanUpEditorUI']),
    iconName() {
      return this.canUseNewCleanUpEditorUI ? 'ChartBar' : 'bar-chart-square'
    },
    iconSize() {
      return this.canUseNewCleanUpEditorUI ? '16' : '20'
    },
  },
}
</script>

<style lang="scss" scoped>
.editor-header-report-button__wrapper {
  @apply flex items-center;
  @media screen and (max-width: 639px){
    @apply mr-1;
  }
}
.editor-header-report-button {
  @apply py-2 px-0 mb-1;
  min-width: 39px;
}
</style>
